import DOMPurify from 'isomorphic-dompurify';

const PURIFY_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'b', 'i', 'u', 'a',
    'ul', 'ol', 'li', 'span', 'h1', 'h2', 'h3', 'h4',
    'blockquote', 'sub', 'sup',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
  ALLOW_DATA_ATTR: false,
};

/**
 * Sanitize HTML from campaign content for safe rendering via dangerouslySetInnerHTML.
 * Strips scripts, event handlers, iframes, embeds, and other injection vectors.
 * Uses the same sanitizer on the server and client so rendered member copy is
 * deterministic across hydration.
 */
export function sanitizeHTML(dirty: string): string {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, PURIFY_CONFIG) as string;
}
